<a [href]="link" class="fixed-button" (click)="clickFlyIcon()">
    <i class="fa fa-whatsapp"></i>
</a>